<template>
  <div class="bto-sb-element">
    <template v-if="isPageNegotiations">
      <div
        class="bto-sb-tost-notification bto-sb-tost-notifications-negotiation"
        @click="openNegotiation()">
        <div class="bto-sb-tost-notification-title">
          {{ generateInfoText() }}
          <span>{{ genereteTimeText(total[0]) }}</span>
        </div>
      </div>
    </template>
    <template v-else>
      <div
        class="bto-sb-tost-notification bto-sb-tost-notifications-negotiation"
        v-for="(nego, index) in getNegotiations"
        :key="index"
        @click="openNegotiation(nego)">
        <div class="bto-sb-tost-notification-title">
          {{ t("Mobile.negotiationshort") }} {{ nego.BetSlipGroupID }}
          <span>{{ genereteTimeText(total[index]) }}</span>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
  import store from '@/store';
  import { genereteTimeText } from '@/services/utils';
  import { EventBus } from '@/services/event-bus-service';
  import NegotiationsService from '../../../services/mybets/negotiations-service';

  export default {
    name: 'NegotiationsToast',
    computed: {
      getNegotiations() {
        return store.state.NegotiationsModule.negotiations.Data || [];
      },
      total() {
        return NegotiationsService.totalNegotiationWidget();
      },
      isMobile() {
        return store.state.GlobalModule.isMobile;
      },
      isPageNegotiations() {
        return this.isMobile || (!process.env.VUE_APP_IS_AGENT && !APP_SETTINGS.settings.modalNegotiations);
      },
    },
    methods: {
      generateInfoText() {
        const numOfNegotiations = this.getNegotiations.length;
        if (numOfNegotiations > 1) {
          const negText = this.$translate.text('M.NegotiationProposalPlural');
          return `${numOfNegotiations} ${negText}`;
        }
        const negText = this.$translate.text('Mobile.negotiationshort');
        return `${negText} ${this.getNegotiations[0].BetSlipGroupID}`;
      },
      openNegotiation(negotiation) {
        if (this.isPageNegotiations) {
          this.$router.push({ name: 'negotiations' });
          return;
        }
        EventBus.$emit('single-negotiate', negotiation);
      },
      genereteTimeText,
    },
  };
</script>